export enum DependencyDirection {
    TopToBottom,
    BottomToTop
}